import React from 'react';
export function Hook() {
  return <section className="bg-softWhite py-20 px-6" data-id="element-46">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-47">
        <p className="text-2xl md:text-3xl font-serif leading-relaxed text-charcoal" data-id="element-48">
          It’s 3:00 AM, and you’re sitting on the nursery floor again. Your back
          is aching, your eyes are burning, and your baby is rigid in your arms,
          fighting sleep like it’s a mortal enemy.
        </p>
        <p className="text-lg md:text-xl font-sans text-charcoal/80 leading-relaxed" data-id="element-49">
          You’ve tried the apps. You’ve followed the "wake windows." You’ve
          bought the $100 swaddles. But the moment their back touches the crib,
          the eyes snap open and the screaming starts. You don’t just feel
          tired—you feel broken.
        </p>
      </div>
    </section>;
}